const TimeZone = {
  install (Vue) {
    Vue.prototype.$timeZone = TimeZone
  },
  timeZone: [
    {
      'num': -20,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-12(IDL-国际换日线)'
      }
    },
    {
      'num': -19,
      'name': {
        'code': 'UTC-11',
        'word': 'UTC-11(MIT-中途岛标准时间)'
      }
    },
    {
      'num': -18,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-10(HST-夏威夷-阿留申标准时间)'
      }
    },
    {
      'num': -17.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-9:30(MSIT-马克萨斯群岛标准时间)'
      }
    },
    {
      'num': -17,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-9(AKST-阿拉斯加标准时间)'
      }
    },
    {
      'num': -16,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-8(PSTA-太平洋标准时间A)'
      }
    },
    {
      'num': -15,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-7(MST-北美山区标准时间)'
      }
    },
    {
      'num': -14,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-6(CST-北美中部标准时间)'
      }
    },
    {
      'num': -13,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-5(EST-北美东部标准时间)'
      }
    },
    {
      'num': -12,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-4(AST-大西洋标准时间)'
      }
    },
    {
      'num': -11.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-3:30(NST-纽芬兰岛标准时间)'
      }
    },
    {
      'num': -11,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-3(SAT-南美标准时间)'
      }
    },
    {
      'num': -10,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-2(BRT-巴西时间)'
      }
    },
    {
      'num': -9,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC-1(CVT-佛得角标准时间)'
      }
    },
    {
      'num': -8,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC(WET-欧洲西部时区，GMT-格林威治标准时间)'
      }
    },
    {
      'num': -7,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+1(CET-欧洲中部时区)'
      }
    },
    {
      'num': -6,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+2(EET-欧洲东部时区)'
      }
    },
    {
      'num': -5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+3(MSK-莫斯科时区)'
      }
    },
    {
      'num': -4.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+3:30(IRT-伊朗标准时间)'
      }
    },
    {
      'num': -4,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+4(META-中东时区A)'
      }
    },
    {
      'num': -3.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+4:30(AFT-阿富汗标准时间)'
      }
    },
    {
      'num': -3,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+5(METB-中东时区B)'
      }
    },
    {
      'num': -2.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+5:30(IDT-印度标准时间)'
      }
    },
    {
      'num': -2.25,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+5:45(NPT-尼泊尔标准时间)'
      }
    },
    {
      'num': -2,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+6(BHT-孟加拉标准时间)'
      }
    },
    {
      'num': -1.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+6:30(MRT-缅甸标准时间)'
      }
    },
    {
      'num': -1,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+7(MST-中南半岛标准时间)'
      }
    },
    {
      'num': 0,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+8(EAT-东亚标准时间/中国标准时间(BJT))'
      }
    },
    {
      'num': 0.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+8:30(KRT-朝鲜标准时间)'
      }
    },
    {
      'num': 1,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+9(FET-远东标准时间)'
      }
    },
    {
      'num': 1.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+9:30(ACST-澳大利亚中部标准时间)'
      }
    },
    {
      'num': 2,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+10(AEST-澳大利亚东部标准时间)'
      }
    },
    {
      'num': 2.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+10:3(FAST-澳大利亚远东标准时间)'
      }
    },
    {
      'num': 3,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+11(VTT-瓦努按图标准时间)'
      }
    },
    {
      'num': 3.5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+11:30(NFT-诺福克岛标准时间)'
      }
    },
    {
      'num': 4,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+12(PSTB-太平洋标准时间B)'
      }
    },
    {
      'num': 4.75,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+12:45(CIT-查塔姆群岛标准时间)'
      }
    },
    {
      'num': 5,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+13(PSTC-太平洋标准时间C)'
      }
    },
    {
      'num': 6,
      'name': {
        'code': 'UTC-12',
        'word': 'UTC+14(PSTD-太平洋标准时间D)'
      }
    },
  ],
  getEnum (data, key) {
    let obj
    data.forEach(e => {
      if (e.name.cn === key) {
        obj = e
        return
      }
    })
    return obj
  }
}
export default TimeZone



// WEBPACK FOOTER //
// ./src/plugins/TimeZone.js